<template>
  <router-link
    :to="{ name: 'worker-version', params: { versionId: workerVersion.id } }"
    target="_blank"
  >
    <WorkerTypeTag :worker="workerVersion.worker" />
    {{ truncateLong(workerVersion.worker.name) }}
  </router-link>
  <br />
  <small>
    <span
      v-if="workerVersion.tag"
      class="tag"
      :title="`Tagged as ${workerVersion.tag}`"
    >
      <span class="icon is-small">
        <i class="icon-tags"></i>
      </span>
      <span>{{ truncateShort(workerVersion.tag) }}</span>
    </span>
    <span
      v-if="workerVersion.branch"
      class="tag"
      :title="`On branch ${workerVersion.branch}`"
    >
      <span class="icon is-small">
        <i class="icon-git"></i>
      </span>
      <span>{{ truncateShort(workerVersion.branch) }}</span>
    </span>
    <a
      :href="workerVersion.revision_url"
      v-if="workerVersion.revision_url"
      class="tag is-light is-link"
      target="_blank"
    >
      <span class="icon is-small">
        <i class="icon-link"></i>
      </span>
      <span>Source code</span>
    </a>
    <span
      class="tag"
      v-else
    >
      Version {{ workerVersion.version }}
    </span>
  </small>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import { truncateMixin } from '@/mixins'
import type { WorkerVersion } from '@/types/worker'

import WorkerTypeTag from '../WorkerRuns/WorkerTypeTag.vue'

export default defineComponent({
  components: {
    WorkerTypeTag,
  },
  props: {
    workerVersion: {
      type: Object as PropType<WorkerVersion>,
      required: true,
    },
  },
  mixins: [truncateMixin],
})
</script>

<style scoped>
.tag {
  margin-top: 0.5em;
  margin-left: 0.5em;
}
</style>
